export { default } from './certificates-collaborator-page';
